export default __webpack_public_path__ + "static/media/ODWAGA.ceb2eb67.png";